export const getSelectedMarker =state=> state.mapview.selectedMarker;
